import React from 'react';
import ComprehensiveHealthDashboard from './ComprehensiveHealthDashboard';

/**
 * Unified Health Wellness Dashboard
 * This component now serves as a wrapper for the new ComprehensiveHealthDashboard.
 * It passes the patientId to the new dashboard.
 * This approach maintains the existing routing and component structure while introducing the new unified view.
 */
const UnifiedHealthWellnessDashboard = ({ patientId, refreshTrigger }) => {
  return <ComprehensiveHealthDashboard patientId={patientId} refreshTrigger={refreshTrigger} />;
};

export default UnifiedHealthWellnessDashboard;
